/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

/**
 * LP spread in BPS by requested USD volume
 */
export interface LpSpreadDto {
  /**
   * LP pair, contains liquidity provider ID.
   */
  lpPair: Pair;
  /**
   * Spread in BPS for 1 000 USD volume. Null - not enough liquidity.
   */
  bps1k?: number;
  /**
   * Spread in BPS for 10 000 USD volume. Null - not enough liquidity.
   */
  bps10k?: number;
  /**
   * Spread in BPS for 100 000 USD volume. Null - not enough liquidity.
   */
  bps100k?: number;
  /**
   * Spread in BPS for 1 000 000 USD volume. Null - not enough liquidity.
   */
  bps1m?: number;
}
